// @flow
import { useTranslation } from 'react-i18next'

import PlainNav, { NavItem } from 'app/common/ui/PlainNav'


type Props = {
  baseUrlGeneral: string,
  baseUrlCamp: string,
}

const NavigationSchoolType = ({ baseUrlGeneral, baseUrlCamp }: Props) => {
  const { t } = useTranslation('cafeteria')

  return (
    <PlainNav>
      <NavItem to={baseUrlGeneral}>{t('navcamp_school', 'Питание в школе')}</NavItem>
      <NavItem to={baseUrlCamp}>{t('navcamp_camp', 'Питание в лагере')}</NavItem>
    </PlainNav>
  )
}

export default NavigationSchoolType
